import { render, staticRenderFns } from "./DataListVehicule_validate.vue?vue&type=template&id=4f71ca04&scoped=true&"
import script from "./DataListVehicule_validate.vue?vue&type=script&lang=js&"
export * from "./DataListVehicule_validate.vue?vue&type=script&lang=js&"
import style0 from "./DataListVehicule_validate.vue?vue&type=style&index=0&id=4f71ca04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f71ca04",
  null
  
)

export default component.exports